module.exports = __webpack_public_path__ + "img/槐米.0a124729.jpg";